var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon2DSdf = function SvgIcon2DSdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_2d_sdf_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.602 1.6H3.41c-.991 0-1.798.808-1.798 1.8v3.763l-.012.012.012.012v4.218l-.012.012.012.012V12.6c0 .992.807 1.8 1.798 1.8h9.192c.99 0 1.798-.808 1.798-1.8V3.4c0-.992-.807-1.8-1.798-1.8Zm.6 6.758L8.363 13.2H5.82l7.381-7.388v2.546ZM2.81 3.4c0-.33.269-.6.599-.6h2.561l-3.16 3.163V3.4Zm0 4.26L7.666 2.8h2.543l-7.398 7.405V7.66Zm0 4.94v-.698L11.905 2.8h.697c.33 0 .6.27.6.6v.716L4.124 13.2H3.41a.6.6 0 0 1-.6-.6Zm9.79.6H10.06l3.142-3.145V12.6a.6.6 0 0 1-.6.6Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_2d_sdf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
};
export default SvgIcon2DSdf;